import { render } from "./HelpModal.vue?vue&type=template&id=695cb78c&scoped=true&ts=true"
import script from "./HelpModal.vue?vue&type=script&lang=ts"
export * from "./HelpModal.vue?vue&type=script&lang=ts"

import "./HelpModal.vue?vue&type=style&index=0&id=695cb78c&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695cb78c"]])

export default __exports__